PerfLogger.$inject = ['$timeout'];

function PerfLogger($timeout) {
    const logs = [];
    let timeout;

    this.record = log => {
        logs.push(log);

        if (timeout) $timeout.cancel(timeout);

        timeout = $timeout(() => console.log(average(logs)), 1000);
    };

    function average(array) {
        return array.reduce((a, b) => a + b) / array.length;
    }
}

export default PerfLogger;



// WEBPACK FOOTER //
// ./src/js/services/perflogger/index.js